const ShinyGradient = () => (
  <svg width="0" height="0" style={{ position: 'absolute' }}>
    <defs>
      <linearGradient id="shinyTransparentGray" x1="0%" y1="0%" x2="100%" y2="100%">
        {/* 1. Icy white highlight at the top */}
        <stop offset="0%" stopColor="#FFFFFF" stopOpacity={0.9} />
        
        {/* 2. Smooth shift to a blueish-silver midtone */}
        <stop offset="45%" stopColor="#A3B1BC" stopOpacity={0.6} />
        
        {/* 3. Sudden dark contrast line (This creates the "glossy" reflection!) */}
        <stop offset="50%" stopColor="#7B8B97" stopOpacity={0.4} />
        
        {/* 4. Bottom bounce light catching the metal edge */}
        <stop offset="100%" stopColor="#D4DCE2" stopOpacity={0.8} />
      </linearGradient>
    </defs>
  </svg>
);

export default ShinyGradient;